import { useFormik } from "formik";
import React, { useState } from "react";
// import ReCAPTCHA from "react-google-recaptcha";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { SignIn as SignInAction } from "../../Api/SignUp";
import TextFiled from "../../components/common/InputField/TextFiled";
import MainButton from "../../components/common/MainButton/MainButton";
import PasswordField from "../../components/common/PasswordField/PasswordField";
import Heading from "../../components/common/Typography/Heading";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import Spinner from "../../components/common/Spinner";
import Popup from "../../components/popup/Popup";
import { POPUP_FORM_CONTENT_CLASS } from "../../components/popup/popupLayoutSpec";
import ForgotPassword from "../../sections/Login/ForgotPassword/ForgotPassword";
import VerificationPopUp from "../../sections/VerificationPop/VerificationPopUp";

import Alerts from "../../components/common/Alerts/Alerts";
import { useGraphQL } from "../../context/GraphQLProvider";
import { LoginQuery } from "../../services/LoginService";
import {jwtDecode } from "jwt-decode";


import {
  InitialValues,
  validationSchema,
} from "../../FormValidations/SignInSchema";
import useAuth from "../../Hooks/useAuth";
import { useEffect } from "react";
import InteractiveText from "../../components/common/Typography/InteractiveText";
import SpecialText from "../../components/common/Typography/SpecialText";
import { handleLogin } from "../../utils/authUtils";
import { useDispatch, useSelector } from "react-redux";
import StepBackButton from "../../components/common/StepBackButton/StepBackButton";
import { clearRedirectPath } from '../../Redux/Slice/authRedirectSlice';

const Login = ({
  SignIn,
  setSignIn,
  SignUpState,
  setSignUpState,
  location: redirect,
  onLoginSuccess,
  // userDetails,
}) => {
  const graphqlService = useGraphQL();
  const [PasswordType, setPasswordType] = useState("true");
  // const [validCaptcha, setValidCaptcha] = useState(false);
  const [VerificationError, setVerificationError] = useState({
    isCredentialsMatched: false,
  });
  const USER_TYPE = {
    CUSTOMER: "customer",
    SELLLER: "seller",
  };
  const [RequestStart, setRequetStart] = useState(false);
  // const [UserType, setUserType] = useState(USER_TYPE.CUSTOMER);
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showEmailField, setShowEmailField] = useState(false);
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [emailStep, setEmailStep] = useState(false);
  const [passwordStep, setPasswordStep] = useState(false);
  const redirectPath = useSelector(state => state.authRedirect.redirectPath);
  // const location = useLocation();
  // let from = location.state?.from?.pathname;
  // if (location?.state?.from?.pathname) from = location.state.from.pathname;
  // else if (location?.pathname) from = location.pathname;
  // else if (redirect) from = redirect;
  // else from = "CustomerDashboard";

  // Helper function to reset all state variables
  const resetAllState = () => {
    setShowEmailField(false);
    setShowPasswordField(false);
    setEmailStep(false);
    setPasswordStep(false);
    setStep(1);
    setRequetStart(false);
    setPasswordType("true");
    setShowCrossButton(true);
    setVerificationError({
      isCredentialsMatched: false,
    });
    formik.resetForm();
  };

  const LoginUser = async (gql, email, password) => {
    const success = await handleLogin(gql, email, password, {
      setRequetStart,
      setAuth,
      setSignIn,
      navigate,
      dispatch,
      redirectPath,
      clearRedirectPath
    });
    if (success && onLoginSuccess) {
      // Reset all state after successful login
      resetAllState();
      
      // Call onLoginSuccess immediately without delay to prevent blink
      onLoginSuccess();
    }
  }

  const formik = useFormik(
    {
      initialValues: InitialValues,
      validationSchema: validationSchema,
      onSubmit: (values, { resetForm }) => {
        // setRequetStart(true);
        // if (!validCaptcha) {
        //   setRequetStart(false);
        //   toast.error("reCAPTCHA required!", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     transition: Flip,
        //   });
        // } else {


        // const SignInUser = {
        //   Email: values.email,
        //   Password: values.password,
        //   ConfirmPassword: values.password,
        // };

        LoginUser(graphqlService, values.email, values.password);

        // SignInAction(SignInUser)
        //   .then((response) => {
        //     if (response.status === 200) {
        //       const accessToken = response?.data?.token;
        //       const expireAt = response?.data?.tokenExpire;
        //       const roles = response?.data?.userRoles?.$values;
        //       const user = response?.data?.key;
        //       const subscription = response?.data?.matrix?.subscription;
        //       const userDetails = {
        //         accessToken,
        //         roles,
        //         user,
        //         expireAt,
        //         subscription,
        //       };
        //       setRequetStart(false);
        //       localStorage.setItem("LoginSession", JSON.stringify(userDetails));
        //       setAuth(userDetails);
        //       setSignIn(!SignIn);
        //       // console.log("UserDetails", userDetails);
        //       // setValidCaptcha(false);
        //       navigate("/");
        //       if (
        //         roles?.filter((e) => e.roleName === USER_TYPE.SELLLER).length >
        //         0
        //       ) {
        //         navigate({ pathname: "/Services" }, { replace: true });
        //       } else navigate({ pathname: from }, { replace: true });
        //     }
        //   })
        //   .catch((error) => {
        //     setRequetStart(false);
        //     toast.error("Username or Password is Incorrect", {
        //       position: toast.POSITION.TOP_RIGHT,
        //       transition: Flip,
        //     });
        //   });
      },
    }
    // }
  );

  const handleEmailStep = () => {
    setShowEmailField(true);
    setEmailStep(true);
    setPasswordStep(false);
    setShowPasswordField(false);
  };

  const handleEmailNext = (e) => {
    e.preventDefault();
    if (formik.values.email && !formik.errors.email) {
      setShowPasswordField(true);
      setPasswordStep(true);
      setEmailStep(false);
    } else {
      formik.setFieldTouched('email', true);
    }
  };

  const handlePasswordLogin = () => {
    if (formik.values.password && !formik.errors.password) {
      formik.handleSubmit();
    } else {
      formik.setFieldTouched('password', true);
    }
  };

  const handleBackToEmail = () => {
    setShowPasswordField(false);
    setPasswordStep(false);
    setShowEmailField(true);
    setEmailStep(true);
  };

  const handleBackToInitial = () => {
    resetAllState();
  };

  const handleGoogleLogin = () => {
    // TODO: Implement Google login functionality
  };

  const [ShowCrossButton, setShowCrossButton] = useState(true);
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (SignIn || SignUpState) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [SignIn, SignUpState]);

  // Reset form and state when popup is opened/closed
  useEffect(() => {
    if (!SignIn) {
      // Reset all state when popup is closed
      resetAllState();
    }
  }, [SignIn]);
  
  return (
    <>
      <ToastContainer autoClose={2000} />
      {SignIn && (
        <Popup
          onClose={() => {
            resetAllState();
            setSignIn(false);
          }}
          setTrigger={setSignIn}
          modelType="SignIn"
          ShowCrossButton={ShowCrossButton}
          cross={true}
        >
          {RequestStart && <Spinner />}
          {step === 1 && (
            <>
              <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
                <div className={POPUP_FORM_CONTENT_CLASS}>
                  <Heading
                    variant={"h6"}
                    className={
                      "flex items-center justify-center text-center"
                    }
                  >
                    {!showEmailField && !showPasswordField && "Login Your Account"}
                    {showEmailField && !showPasswordField && "Enter your email"}
                    {showPasswordField && "Enter your password"}
                  </Heading>
                  <div className="mt-10 xl:mt-8 w-full">
                    <form>
                      {/* Email field - only show when in email step */}
                      {showEmailField && !showPasswordField && (
                        <div className="flex justify-center w-full">
                          <div className="w-full mx-auto">
                            <TextFiled
                              className={"bg-white autofill:bg-white border border-solid border-[#C0C0C0]"}
                              label={"Email"}
                              variant={"medium"}
                              fullWidth
                              type="email"
                              name="email"
                              placeholder={"Enter your registered email"}
                              onChange={formik?.handleChange}
                              value={formik?.values?.email}
                              error={formik.touched.email && formik.errors.email ? formik.errors.email : null}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  if (formik.values.email && !formik.errors.email) {
                                    handleEmailNext(e);
                                  } else {
                                    formik.setFieldTouched('email', true);
                                  }
                                }
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {/* Password field - only show when in password step */}
                      {showPasswordField && (
                        <div className="flex justify-center w-full">
                          <div className="w-full mx-auto">
                            <label className="mb-2 block">
                              <AuxiliaryText
                                variant={"FieldLabel"}
                                className={"text-offblack"}
                              >
                                Password
                              </AuxiliaryText>
                            </label>
                            <PasswordField
                              fullWidth
                              passwordtype={PasswordType}
                              setpasswordtype={setPasswordType}
                              name="password"
                              placeholder={"Enter your associated password"}
                              onChange={formik?.handleChange}
                              value={formik?.values?.password}
                              error={formik.touched.password && formik.errors.password ? formik.errors.password : null}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  if (formik.values.password && !formik.errors.password) {
                                    handlePasswordLogin();
                                  } else {
                                    formik.setFieldTouched('password', true);
                                  }
                                }
                              }}
                            />
                            <div className="flex justify-end mt-1">
                              <button
                                className="text-primaryblue cursor-pointer"
                                type="button"
                                onClick={() => setStep(2)}
                              >
                                <InteractiveText variant={"ActionLink"}>
                                  Forgot password
                                </InteractiveText>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Next button for email step */}
                      {showEmailField && !showPasswordField && (
                        <div className="flex justify-center w-full">
                          <div className="w-full mx-auto">
                            <div className="flex items-center justify-between mt-10 w-full">
                              <StepBackButton onClick={handleBackToInitial} />
                              <MainButton
                                variant={"small"}
                                onClick={handleEmailNext}
                              >
                                Next
                              </MainButton>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Login button for password step */}
                      {showPasswordField && (
                        <div className="flex justify-center w-full">
                          <div className="w-full mx-auto">
                            <div className="flex items-center justify-between mt-10 w-full">
                              <StepBackButton onClick={handleBackToEmail} />
                              <MainButton
                                variant={"small"}
                                onClick={handlePasswordLogin}
                              >
                                Login
                              </MainButton>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Initial buttons - only show when no fields are visible */}
                      {!showEmailField && !showPasswordField && (
                        <>
                          <div className="flex flex-col items-center justify-center">
                            <MainButton variant={"loginSignup"} className="!w-full" type="button" onClick={handleGoogleLogin}>
                              <img src={require('../../assets/img/google-logo.png')} className="mr-3" />
                              Login with Google
                            </MainButton>
                          </div>
                          <div className="flex flex-col items-center justify-center mt-3">
                            <MainButton 
                              variant={"loginSignup"} 
                              className="!w-full" 
                              onClick={handleEmailStep}
                            >
                              <img src={require('../../assets/img/letter-icon.png')} className="group-hover:invert mr-3 -ml-1" />
                              Login with Email
                            </MainButton>
                          </div>
                        </>
                      )}
                    </form>
                  </div>
                  {/* Terms and Conditions - only show in initial state */}
                  {!showEmailField && !showPasswordField && (
                    <div className="flex justify-center left-0 w-full mt-9">
                      <SpecialText
                        variant={"Caption"}
                        className="mt-auto xl:w-full text-center text-[#232A2E]"
                      >
                        By continuing, you agree to the <span
                          className="cursor-pointer underline hover:text-primaryblue"
                          onClick={() => {
                            resetAllState();
                            setSignIn(false);
                            navigate("/terms-&-conditions");
                          }}
                        >Terms</span> and <span
                        className="cursor-pointer underline hover:text-primaryblue"
                        onClick={() => {
                          resetAllState();
                          setSignIn(false);
                          navigate("/privacy-policy");
                        }}
                      >Privacy Policies</span> <br />
                      Don't have an account? <span
                          className="cursor-pointer underline hover:text-primaryblue"
                          onClick={() => {
                            resetAllState();
                            setSignIn(false);
                            setSignUpState(true);
                          }}
                        >Create</span>
                      </SpecialText>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
          {step === 2 && (
            <>
              <ForgotPassword
                onClickHandler={() => {
                  setStep(3);
                }}
                onBackToLogin={() => {
                  resetAllState();
                }}
              />
            </>
          )}
          {step === 3 && (
            <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
              <div className={POPUP_FORM_CONTENT_CLASS}>
                <VerificationPopUp
                  Headingh6={true}
                  Headingh5={true}
                  secondHeadingh6={true}
                  secondHeadingh5={true}
                  closePopup={() => resetAllState()}
                  firstMainHeading={"Email Verification"}
                  label={"Verification code"}
                  placeholder={"Enter the code here"}
                  secondMainHeading={"Password updated !!!"}
                  secondP={
                    "Your password has been successfully updated! You can now securely log in to your account using your new password."
                  }
                  buttonText={"Submit"}
                />
              </div>
            </div>
          )}
        </Popup>
      )}
    </>
  );
};

export default Login;
